import './Button.css'

const Button = (props) => {
    return <a href={props.link} className="button" target="blank">{props.children}</a>
}

export default Button